// extracted by mini-css-extract-plugin
module.exports = {"root":"HorizontalList_root__21Hkr","swiping":"HorizontalList_swiping__26BAw","icon-outer":"HorizontalList_icon-outer__3T64m","icon-btn":"HorizontalList_icon-btn__2yS-3"};